import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=1588a5ca&"
import script from "./StartScreen.vue?vue&type=script&lang=js&"
export * from "./StartScreen.vue?vue&type=script&lang=js&"
import style0 from "./StartScreen.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports